<!--
 * @Author: zxf
 * @Date: 2022-08-03 17:39:28
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 16:37:43
 * @Description: 设备其他说明
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-60 o-dialog--lg-50 o-dialog--xl-36"
    :class="{'o-dialog-h--75': showType === 'view'}"
    title="其他说明"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <el-form
      ref="fd"
      class="c-form"
      :model="fd"
      :inline="true"
      label-position="right"
      label-width="110px"
      label-suffix="："
    >
      <!-- v-if="showType === 'edit'" -->
      <el-input
        v-model="fd.qtsm"
        :disabled="showType !== 'edit'"
        class="c-form__input"
        type="textarea"
        rows="10"
        placeholder="请输入其他说明"
      />
      <!-- <span
        v-else
        class="c-form__read"
      >{{ fd.qtsm }}</span> -->
    </el-form>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        v-if="showType === 'edit'"
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>
<script>
import { xfsbService } from './xfsb.service';
export default {
  name: 'JcsbQtsmDialog',
  props: {
    xmId: {
      type: String,
      default: ''
    },
    showType: {
      type: String,
      default: 'view'
    }
  },
  data () {
    return {
      loading: false, // 页面loading计划年份
      dialogShow: true, // 模态框dialog显示

      /* 表单参数 Start */
      fd: {
        qtsm: null
      }
    };
  },
  methods: {
    /**
     * @description: 保存操作
     * @param {*}
     * @return {*}
     */
    handleSave () {
      // 其他说明校验
      if (this.fd.qtsm && this.fd.qtsm.length > 1000) {
        this.$message({
          message: '【其他说明】长度不能超出1000位',
          type: 'warning'
        });
        return;
      }
      const _this = this;
      _this.fd.xmId = _this.xmId;
      _this.$refs.fd.validate((valid) => {
        if (valid) {
          _this.loading = true;
          xfsbService.saveSbqtsm(_this.fd)
            .then(rsp => {
              _this.$alert('保存成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              _this.$emit('closeDialog', '');
              _this.$emit('callback');
            })
            .catch(err => {
              console.error('保存其他说明信息错误！', err);
              _this.loading = false;
            });
        }
      });
    },
    /**
     * @description: 获取其他说明信息
     * @return {*}
     */
    getInfo () {
      xfsbService.getSbqtsm(this.xmId)
        .then(rsp => {
          this.fd.qtsm = rsp.data;
        })
        .catch(err => {
          console.error('获取其他说明信息失败！', err);
        });
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    this.getInfo();
  }
};
</script>
